import { Box, Typography } from '@mui/material'

export default function Disclaimer() {
  return (
    <Box
      component="section"
      sx={{
        textAlign: 'center',
        margin: { xs: '80px 0 0', md: '140px 0 0', lg: '240px 0 0' },
        padding: { xs: '0 10px', md: '0 75px', lg: '0 140px', xl: '0 10px' }
      }}
    >
      <Typography paragraph sx={{ color: '#344054', fontFamily: '"proxima-nova", sans-serif', fontSize: { xs: '0.75rem', lg: '1' } }}>
        Apple, Inc and Google, LLC are not affiliated with Photobucket.com, Inc.
      </Typography>
    </Box>
  )
}
